import { Link } from "react-router-dom";
import { MonitorGroup } from "../types";

interface GroupCardProps {
  group: MonitorGroup;
  monitorCount: number;
  onDelete?: () => void;
}

export default function GroupCard({ group, monitorCount, onDelete }: GroupCardProps) {
  return (
    <div
      className="glass"
      style={{
        display: "flex",
        alignItems: "stretch",
        overflow: "hidden",
        borderRadius: 3,
      }}
    >
      <div style={{ width: 4, background: group.color, flexShrink: 0 }} />
      <div style={{ flex: 1, padding: "16px 20px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <Link
            to={`/dashboard/monitor-groups/${group.id}`}
            style={{ color: "#EFF2F5", fontWeight: 600, fontSize: 15, textDecoration: "none" }}
          >
            {group.name}
          </Link>
          <p style={{ margin: "3px 0 0", fontSize: 12, color: "#98A1AB" }}>
            {monitorCount} {monitorCount === 1 ? "monitor" : "monitors"}
          </p>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Link
            to={`/dashboard/monitor-groups/${group.id}`}
            style={{ fontSize: 12, color: "#98A1AB", textDecoration: "none", padding: "4px 10px", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 3 }}
          >
            View
          </Link>
          {onDelete && (
            <button
              onClick={onDelete}
              style={{ background: "none", border: "none", cursor: "pointer", color: "#98A1AB", fontSize: 18, padding: "0 4px", lineHeight: 1 }}
              title="Delete group"
            >
              ×
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
